export const toResponse = (response: any) => {
  if (!response.success) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${
        response.errorMessage
      }`
    );
  }

  return response.result;
};



// WEBPACK FOOTER //
// ./src/services/api/genericToResponse.ts